import api from '../common/api/serieApi';

const basePath = '/series';

export default {
  getList(params = {}) {
    return api.get(basePath, { params });
  },
  create(serie) {
    return api.post(basePath, serie);
  },
  get(serieId, params = {}) {
    return api.get(`${basePath}/${serieId}`, { params });
  },
  update(serieId, serie) {
    return api.put(`${basePath}/${serieId}`, serie);
  },
  delete(SerieId) {
    return api.delete(`${basePath}/${SerieId}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/serieService.js